module.exports = __webpack_public_path__ + "img/404.63db60bb.gif";